<div class="page-container">
  <app-configurable-grid
    headerTitle="Packaging"
    [config]="gridConfig">
  </app-configurable-grid>
</div>
